// extracted by mini-css-extract-plugin
export default {"wrap":"fF-z","fullWidth":"gF-z","hideOnDesktop":"hF-z","content":"iF-z","hasOpenedNav":"jF-z","crumbsList":"kF-z","dropdownsWrap":"lF-z"};